import React from 'react';
import { Col, Row, Button, Modal, Form, InputGroup } from 'react-bootstrap';
import { SearchIcon } from '../ui/icons';
import TreeView from '../treeView';
import { useUpdateUserModal } from "./useUpdateUserModal";

const EditUserModal = () => {

  const { checkedBox, isModalActive, handleOnSubmit, email, setEmail, phoneNumber, setPhoneNumber, name, setName, role, setRole, handleClose, groupSearchQuery, handleGroupInputChange, setIsEmptyGroupShown, setSearchTerm, nodesToDisplay, handleDataFromTreeView, isCurrentUser } = useUpdateUserModal();


  return (
    <>
      <Modal show={isModalActive} onHide={handleClose} className="modal-container" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit User</Modal.Title>
        </Modal.Header>
        <Form>
          <Modal.Body>
            <div className='add-group-container'>
              <Row>
                <Col sm={5}>

                  <div className='email-address-notify'>
                    <label>Email</label>
                    <Form.Control type='email' disabled placeholder='Enter Email Address' value={email} onChange={(e) => setEmail(e.target.value)}></Form.Control>
                  </div>


                  <div className='email-address-notify'>
                    <label>Phone Number</label>
                    <Form.Control type='number' placeholder='Enter Phone Number' value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}></Form.Control>
                  </div>


                  <div className='email-address-notify'>
                    <label>Name</label>
                    <Form.Control type='text' placeholder='Enter Name' value={name} onChange={(e) => setName(e.target.value)}></Form.Control>
                  </div>

                  <div className="assign-roles-select">
                    <Form.Label>Choose Role Type</Form.Label>
                    <Form.Select aria-label="Choose Role Type" onChange={(e) => setRole(e.target.value)} value={role} disabled={isCurrentUser}>
                      <option value="">Select Role</option>
                      {/* use this value from env file and add loop over option*/}
                      <option value="c495eb57-eb18-489e-9802-62c474e5645c">Admin</option>
                      <option value="b4935647-30e4-4ed3-9074-dcac66c2f8ef">Operator</option>
                      <option value="84cc62c1-dabe-49d3-b16e-8b291232b285">Viewer</option>
                    </Form.Select>
                  </div>
                </Col>
                <Col sm={1}>
                  <div className='line'></div>
                </Col>
                <Col sm={6}>
                  <div className="assign-roles-tree-container">
                    <div className="assign-roles-search">
                      <InputGroup>
                        <Form.Control placeholder="Search" aria-label="Search" aria-describedby="search-tree-list" value={groupSearchQuery} onChange={handleGroupInputChange} />
                        <InputGroup.Text id="search-tree-list"><SearchIcon /></InputGroup.Text>
                      </InputGroup>
                    </div>
                    <div className="assign-roles-tree">
                      <TreeView
                        checkedBox={checkedBox}
                        setIsEmptyGroupShown={setIsEmptyGroupShown}
                        setSearchTerm={setSearchTerm}
                        nodes={nodesToDisplay}
                        onDataFromTreeView={handleDataFromTreeView}
                        isModalOrg={true}
                      ></TreeView>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn-cancel' onClick={handleClose}>
              Cancel
            </Button>
            <Button className='btn-style' type='submit' onClick={handleOnSubmit}>
              Edit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default EditUserModal;